import React from 'react';
import axios from 'axios';
import Dropzone from 'react-dropzone';
import {
  Box,
  Typography,
  Backdrop,
  CircularProgress,
} from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import {
  BASE_API,
  COMPANY_SIGNED_IN_BACKGROUND_COLOR,
  GENERAL_TEXT_COLOR,
  BUTTON_BACKGROUND_COLOR,
} from 'config/consts';

const UPLOAD_GENERIC_FILE_URL = `${BASE_API}/files/actions`;

export function uploadGenericFileToS3(file) {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(UPLOAD_GENERIC_FILE_URL, formData, {
    headers: {
      Authorization: `${JSON.parse(localStorage.getItem('USER_TOKEN'))}`,
      'Content-Type': 'multipart/form-data',
    },
  }).then((res) => res.data);
}

export default class InputGenericFile extends React.Component {
  state = {
    uploading: false,
    errorMessage: null,
  };

  onDrop = async (acceptedFiles) => {
    if (!acceptedFiles.length) return;
    const file = acceptedFiles[0];
    this.setState({ uploading: true, errorMessage: null });
    try {
      const data = await uploadGenericFileToS3(file);
      this.props.input.onChange(data);
    } catch (err) {
      this.setState({ errorMessage: err.message || 'Erro no upload' });
    } finally {
      this.setState({ uploading: false });
    }
  };

  render() {
    const { uploading, errorMessage } = this.state;
    const {
      input: { value },
      label,
      meta: { touched, error },
    } = this.props;

    return (
      <>
        <Backdrop
          open={uploading}
          style={{ zIndex: 1500, color: BUTTON_BACKGROUND_COLOR }}
        >
          <CircularProgress color="inherit" />
          <Typography variant="body1" style={{ marginLeft: 10 }}>
            Enviando arquivo...
          </Typography>
        </Backdrop>
        <Box display="flex" flexDirection="column">
          <Dropzone
            onDropAccepted={this.onDrop}
            accept=".pdf,.doc,.docx,.zip,image/*"
            multiple={false}
            maxSize={10 * 1024 * 1024}
            onDropRejected={() =>
              this.setState({ errorMessage: 'Tamanho ou formato inválido' })
            }
          >
            {({ getRootProps, getInputProps }) => (
              <Box
                {...getRootProps()}
                display="flex"
                flexGrow={1}
                p={2}
                style={{
                  borderWidth: 1,
                  borderColor: touched && error ? 'red' : GENERAL_TEXT_COLOR,
                  borderStyle: 'dashed',
                  borderRadius: 5,
                  cursor: 'pointer',
                  backgroundColor: COMPANY_SIGNED_IN_BACKGROUND_COLOR,
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <input {...getInputProps()} />
                {value && value.original_name ? (
                  <>
                    <Typography variant="body1">
                      {value.original_name}
                    </Typography>
                    <Typography variant="caption">
                      Clique para trocar
                    </Typography>
                  </>
                ) : (
                  <>
                    <CloudUploadIcon
                      style={{ fontSize: 40, color: GENERAL_TEXT_COLOR }}
                    />
                    <Typography variant="body2" style={{ marginTop: 8 }}>
                      {label || 'Arraste ou clique para anexar arquivo'}
                    </Typography>
                  </>
                )}
              </Box>
            )}
          </Dropzone>
          {(touched && error) || errorMessage ? (
            <Typography
              variant="caption"
              style={{ color: '#f44336', marginTop: 8 }}
            >
              {(touched && error) || errorMessage}
            </Typography>
          ) : null}
        </Box>
      </>
    );
  }
}
